import type { BlockAsset } from './block-asset'
import type { Asset, EdgeStyles, Link } from './shared'
import type { StoryblokContent } from '~/types/storyblok'

export interface PromoCard extends StoryblokContent {
  component: 'promo-card'

  title: string
  link: Link // IS THIS USED?

  // Settings
  heightLimit: 'none' | 'full' | 'original'
  edgeStyle: EdgeStyles

  // Media - Default & Mobile
  smallAsset: Asset
  smallAssetWidth?: string // TODO: can be remove for next release
  smallAssetHeight?: string // TODO: can be remove for next release
  altTextSmall: string

  // Media - Desktop override
  largeAsset?: Asset
  largeAssetWidth?: string // TODO: can be remove for next release
  largeAssetHeight?: string // TODO: can be remove for next release
  altTextLarge?: string

  // Description
  descriptionText?: string
  textContentAboveTheImage: boolean
  showDescriptionOnMobile: boolean

  // Previous Promo Blok structure
  image?: Asset
  imageAlt?: string
}

export function normalizePromoBlock(blok?: PromoCard) {
  const defaultAsset: BlockAsset | undefined = blok
    ? {
        url: blok.smallAsset.filename || blok.image?.filename || undefined,
        alt: blok.altTextSmall || blok.imageAlt || '',
        aspectRatio: blok.smallAssetWidth && blok.smallAssetHeight
          ? [Number.parseInt(blok.smallAssetWidth), Number.parseInt(blok.smallAssetHeight)]
          : undefined,
      }
    : undefined
  const desktopOverrideAsset: BlockAsset | undefined = blok?.largeAsset?.filename
    ? {
        url: blok?.largeAsset.filename || undefined,
        alt: blok?.altTextLarge || '',
        aspectRatio: blok.largeAssetWidth && blok.largeAssetHeight
          ? [Number.parseInt(blok.largeAssetWidth), Number.parseInt(blok.largeAssetHeight)]
          : undefined,
      }
    : defaultAsset

  return {
    heightLimit: blok?.heightLimit || 'original',
    edgeStyle: blok?.edgeStyle || 'none',
    textContentAboveTheImage: blok?.textContentAboveTheImage || false,
    description: {
      text: blok?.descriptionText || '',
      showDescriptionOnMobile: blok?.showDescriptionOnMobile || false,
    },
    asset: {
      default: defaultAsset,
      desktopOverride: desktopOverrideAsset,
    },
    link: blok?.link.cached_url || '',
  }
}
